import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import {DialogActions} from "@material-ui/core";
import AppointmentCptSelector from "../../../appointment/modals/AppointmentCptSelector";
import FormField from "../../../../components/form/FormField";

class UpdateProceduresModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cptList: [...(this.props.appointment.cptList || [])]
        };
        this.formFieldRef = null;
    }

    handleCptSelected = (cptList) => {
        this.setState({ cptList });
    }

    handleSave = () => {
        if (this.formFieldRef && !this.formFieldRef.validate()) {
            return;
        }
        this.props.onSave(this.props.appointment.id, this.state.cptList);
        this.props.close();
    }

    render() {
        const { appointment } = this.props;
        
        return (
            <div>
                <div style={{padding: '20px'}}>
                    <div style={{marginBottom: '15px'}}>
                        <label style={{fontWeight: 'bold', display: 'block', marginBottom: '8px'}}>
                            Select CPT Codes for this Appointment
                        </label>
                    </div>
                    
                    <FormField
                        ref={formField => this.formFieldRef = formField}
                        validateOn={this.state.cptList}
                        required={true}
                        requiredMessage="At least one CPT code must be selected"
                    >
                        <AppointmentCptSelector
                            cptList={this.state.cptList}
                            staff={appointment.staff}
                            clinicCountry={appointment.room?.clinic?.country}
                            roomName={appointment.room?.name}
                            onCptSelected={this.handleCptSelected}
                        />
                    </FormField>
                </div>
                
                <DialogActions>
                    <Button variant="secondary" onClick={this.props.close}>
                        Cancel
                    </Button>
                    <Button 
                        variant="success"
                        onClick={this.handleSave}
                    >
                        Save Changes
                    </Button>
                </DialogActions>
            </div>
        );
    }
}

export default UpdateProceduresModal;
